import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
declare var jsPlumb: any;

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-flusso-pratica',
  templateUrl: './flusso-pratica.component.html',
  styleUrls: ['./flusso-pratica.component.css']
})
export class FlussoPraticaComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('workflowDiv') workflowDiv;
	defaultStatesSync: Subscription;
	activeFlowSync: Subscription;
	statesDictSync: Subscription;

	init: boolean = true;
	save: boolean = true;
	reset: boolean = false;
	// saved: boolean = false;
	timestamp: number = 0;

	jsPlumbDefaults = {
		Anchor: 'AutoDefault',
		Container: 'wfDiv',
		Overlays: [ ['PlainArrow',{width:10,length:20}] ],
		Connector: "StateMachine",
		DragOptions: {
			containment: true
		},
		PaintStyle: {
			strokeWidth: 2,
			stroke: 'lightsteelblue',
		},
		EndpointStyle: {
			fill:'lightsteelblue',
			radius: 4
		}
	}

	loadedDefaultStates: any[] = [];

	// flowEnv: any = null;

	stateMenuSelected: string;

	selected: any = {};

	modalInput: any = {
		size: 'medium-modal',
		title: 'Titolo',
		subtitle: 'sottotitolo',
		data: {
			saved: false,
			selected: {},
			flowEnv: null
		}
	}

	constructor(protected dataService: DataService) {
		super(dataService, 'flusso-pratica');
	}

	ngOnInit() {
		console.log('INIT FLUSSI');

		this.setEmptyFlowEnv();
		this.resetSelected(false);

		jsPlumb.ready(
			() => {
				console.log('JSPLUMB READY!');
				jsPlumb.importDefaults(this.jsPlumbDefaults);
				console.log('JSPLUMB DEFAULTS IMPORTED');
				this.setBindings();
				console.log('JSPLUMB READY END');
			}
		);

		this.defaultStatesSync = this.dataService.defaultStates$.subscribe(
			states => {
				this.loadedDefaultStates = states;
				console.log('JSPLUMB|states', this.loadedDefaultStates);
			});
		this.activeFlowSync = this.dataService.activeFlow$.subscribe(
			activeFlow => {
				console.log('ACTIVEFLOW|INIT', this.init, activeFlow, this.dataService.flowInit);
				if (activeFlow && this.dataService.flowInit) {
					jsPlumb.reset();
					jsPlumb.importDefaults(this.jsPlumbDefaults);
					this.setBindings();
					this.loadFlow(activeFlow.id);
					this.modalInput.data.flowEnv = activeFlow;
					if (this.modalInput.data.flowEnv) {
						console.log('JSPLUMB|flow yes');
						this.setDefaultStates();
					}
					else {
						console.log('JSPLUMB|flow no');
						this.setEmptyFlowEnv();
						this.loadFlow(activeFlow.id);
					}
					this.dataService.flowInit = false;
				}
			});
	}

	newFlow(flowData: any) {
		this.timestamp = Date.now();
		this.modalInput.data.flowEnv.id = '';
		this.modalInput.data.flowEnv.nome = flowData.name;
		this.modalInput.data.flowEnv.descrizione = flowData.description;
		this.modalInput.data.flowEnv.creazione = Math.floor(this.timestamp/1000);
		this.modalInput.data.flowEnv.aggiornamento = Math.floor(this.timestamp/1000);
		this.modalInput.data.flowEnv.attivo = -1;
		console.log('NEW FLOW', this.modalInput.data.flowEnv);
		this.startReset();
	}

	startReset() {
		this.save = false;
		let wfStates: any[] = [];
		for (let state of this.modalInput.data.flowEnv.contenuto.workflow.states) {
			wfStates.push(state);
		}
		for (let state of wfStates) {
			this.removeStateFromWorkflow(state);
		}
		this.save = true;
		// this.saveFlowLocalStorage();
	}

	setEmptyFlowEnv() {
		console.log('set empty');
		let now: any = Date.now();
		this.dataService.flowInit = true;
		this.modalInput.data.flowEnv = {
			id: '',
			nome: '',
			descrizione: '',
			creazione: now,
			aggiornamento: now,
			attivo: -1,
			obsoleto: -1,
			comune_id: this.dataService.getComuniService().getComuneId(),
			contenuto: {
				stateSettings: {},
				customStates: [],
				defaultStates: [],
				workflow: {
					states: [],
					connections: {}
				}
			}
		}
	}

	setDefaultStates() {
		console.log('A', this.modalInput.data.flowEnv.contenuto.workflow.states);
		for (let state of this.loadedDefaultStates) {
			this.addDefaultState(state);
		}
		this.resetFlowStates();
		// this.redrawConnections();
	}

	addDefaultState(state: any) {
		let defaultState: any = {
			id: state.id,
			nome: state.nome,
			descrizione: state.descrizione,
			tipo: 'default',
			codice: state.codice,
			atto: Boolean(state.atto),
			bollettino: Boolean(state.bollettino),
			rate: Boolean(state.rate)
		}

		if ( !this.modalInput.data.flowEnv.contenuto.stateSettings.hasOwnProperty(defaultState.id) ) {
			let settings: any = {
				top: '0px',
				left: '0px',
				delayValue: 0,
				delayCondition: '==',
				delayField: '',
				cashValue: 0,
				cashCondition: '==',
				cashField: '',
			}

			this.modalInput.data.flowEnv.contenuto.stateSettings[defaultState.id] = settings;
		}

		if ( this.modalInput.data.flowEnv.contenuto.workflow.states.length || this.modalInput.data.flowEnv.contenuto.defaultStates.length ) {
			for (let state of this.modalInput.data.flowEnv.contenuto.workflow.states) {
				if (state.id == defaultState.id) {
					let index = this.modalInput.data.flowEnv.contenuto.workflow.states.indexOf(state);
					console.log('addDefaultState A',index);
					this.modalInput.data.flowEnv.contenuto.workflow.states[index] = defaultState;
					return
				}
			}
			for (let state of this.modalInput.data.flowEnv.contenuto.defaultStates) {
				if (state.id == defaultState.id) {
					let index = this.modalInput.data.flowEnv.contenuto.defaultStates.indexOf(state);
					console.log('addDefaultState B',index);
					this.modalInput.data.flowEnv.contenuto.defaultStates[index] = defaultState;
					return
				}
			}
			this.modalInput.data.flowEnv.contenuto.defaultStates.push(defaultState);
		}
		else {
			this.modalInput.data.flowEnv.contenuto.defaultStates.push(defaultState);
		}
	}

	resetFlowStates() {
		console.log('B', this.modalInput.data.flowEnv.contenuto.workflow.states);
		let counter: number = 0;
		for (let state of this.modalInput.data.flowEnv.contenuto.workflow.states) {
			setTimeout( () => {
				console.log('resetting', state.id);
				jsPlumb.draggable( state.id , {
					stop: ($event: any) => {
						let id = $event.el.id;
						let top = $event.finalPos[1];
						let left = $event.finalPos[0];
						this.updateState(id,top,left);
					}
				} );
				jsPlumb.makeSource( state.id ,{
					filter: '.connector',
				});
				jsPlumb.makeTarget( state.id ,{
					allowLoopback:false
				});
				counter++;
				if ( counter == this.modalInput.data.flowEnv.contenuto.workflow.states.length ) {
					this.redrawConnections();
				}
			} , 250);
		}
	}

	redrawConnections() {
		console.log('redrawConnections');
		for (let source in this.modalInput.data.flowEnv.contenuto.workflow.connections) {
			for (let target of this.modalInput.data.flowEnv.contenuto.workflow.connections[source]) {
				console.log('connecting', source,target);
				this.connectStates(source, target);
			}
		}
		// this.save = true;
		// this.reset = false;
		this.modalInput.data.saved = true;
	}

	resetSelected(newState:boolean) {
		this.modalInput.size = 'medium-modal';
		this.modalInput.title = 'Nuovo Stato';
		this.modalInput.subtitle = 'Aggiungi uno Stato Custom';
		this.modalInput.height = 'fluid';
		this.modalInput.data.selected = {
			newState: newState,
			state: {
				id: String(Math.floor(Date.now()/1000)),
				nome: '',
				descrizione: '',
				tipo: 'custom',
				codice: '',
				atto: false,
				bollettino: false,
				rate: false
			},
			settings: {
				top: '0px',
				left: '0px',
				delayField: '',
				delayCondition: '==',
				delayValue: 0,
				cashField: '',
				cashCondition: '==',
				cashValue: 0
			}
		}
	}

	createCustomState(data: any) {
		let newState: any = {
			id: data.state.id,
			nome: data.state.nome,
			descrizione: data.state.descrizione,
			tipo: 'custom',
			codice: data.state.codice,
			atto: false,
			bollettino: false,
			rate: false
		};

		let settings: any = {
			top: '0px',
			left: '0px',
			delayValue: data.settings.delayValue,
			delayCondition: data.settings.delayCondition,
			delayField: data.settings.delayField,
			cashValue: data.settings.cashValue,
			cashCondition: data.settings.cashCondition,
			cashField: data.settings.cashField
		}

		this.modalInput.data.flowEnv.contenuto.stateSettings[newState.id] = settings;

		this.modalInput.data.flowEnv.contenuto.customStates.push(newState);
	}

	eraseCustomState(state: any) {
		delete this.modalInput.data.flowEnv.contenuto.stateSettings[state.id];
		this.modalInput.data.flowEnv.contenuto.customStates.splice( this.modalInput.data.flowEnv.contenuto.customStates.indexOf(state) , 1 );
		// this.saveFlowLocalStorage();
	}

	setBindings() {
		if (!this.checkPermission('flusso-pratica','write')) {
			jsPlumb.bind( 'beforeDrop', () => false);
			jsPlumb.bind( 'beforeDetach', () => false);
			jsPlumb.bind( 'beforeDrag', () => false);
			jsPlumb.bind( 'beforeStartDetach', () => false);
		}

		jsPlumb.bind( 'connection' , (connection: any) => {
			console.log('CONNECTED', connection);
			this.makeConnection(connection);
		});

		jsPlumb.bind( 'connectionDetached' , (connection: any) => {
			console.log('DETACHED', connection);
			this.detachConnection(connection);
		});

		jsPlumb.bind( 'connectionMoved' , (connection: any) => {
			console.log('MOVED', connection);
			this.moveConnection(connection);
		});
	}

	connectStates(source:string, target:string) {
		jsPlumb.connect({
			source: source,
			target: target
		});
	}

	addStateToWorkflow($event: any, state: any) {
		this.modalInput.data.flowEnv.contenuto.stateSettings[state.id].top = $event.mouseEvent.offsetY+'px';
		this.modalInput.data.flowEnv.contenuto.stateSettings[state.id].left = $event.mouseEvent.offsetX+'px';

		if (state.tipo == 'default') {
			this.modalInput.data.flowEnv.contenuto.defaultStates.splice( this.modalInput.data.flowEnv.contenuto.defaultStates.indexOf(state) , 1);
		}
		else {
			this.modalInput.data.flowEnv.contenuto.customStates.splice( this.modalInput.data.flowEnv.contenuto.customStates.indexOf(state) , 1);
		}

		this.modalInput.data.flowEnv.contenuto.workflow.states.push(state);
		this.modalInput.data.flowEnv.contenuto.workflow.connections[state.id] = [];

		setTimeout( () => {
			jsPlumb.draggable( state.id , {
				stop: ($event:any) => {
					let id = $event.el.id;
					let top = $event.finalPos[1];
					let left = $event.finalPos[0];
					this.updateState(id,top,left);
				}
			} );
			jsPlumb.makeSource( state.id ,{
				filter: '.connector',
			});
			jsPlumb.makeTarget( state.id ,{
				allowLoopback: false
			});
		} , 500);

		// this.saveFlowLocalStorage();
	}

	activeStateContextMenu($event: any, state: string) {
		$event.preventDefault();
		if (this.checkPermission('flusso-pratica','write')) {
			if (this.stateMenuSelected == state) {
				this.closeStateMenu();
			}
			else {
				this.openStateMenu(state);
			}
		}
	}

	openStateMenu(state: string) {
		this.stateMenuSelected = state;
	}

	closeStateMenu() {
		this.stateMenuSelected = '';
	}

	removeStateFromWorkflow(state: any) {
		//jsPlumb.detachAllConnections(state.id);
		jsPlumb.deleteConnectionsForElement(state.id);
		this.stateMenuSelected = '';
		this.modalInput.data.flowEnv.contenuto.workflow.states.splice( this.modalInput.data.flowEnv.contenuto.workflow.states.indexOf(state) , 1);
		if (state.tipo == 'default') {
			this.modalInput.data.flowEnv.contenuto.defaultStates.push(state);
		}
		else {
			this.modalInput.data.flowEnv.contenuto.customStates.push(state);
		}

		delete this.modalInput.data.flowEnv.contenuto.workflow.connections[state.id];
		// this.saveFlowLocalStorage();
		// this.setEmptyFlowEnv();
	}

	updateState(id: string, top: number, left: number) {
		this.modalInput.data.flowEnv.contenuto.stateSettings[id].top = top+'px';
		this.modalInput.data.flowEnv.contenuto.stateSettings[id].left = left+'px';
		this.modalInput.data.saved = false;
		// this.saveFlowLocalStorage();
	}

	makeConnection(conn: any) {
		let source = conn.sourceId;
		this.saveConnections(source);
	}

	detachConnection(conn: any) {
		let source = conn.sourceId;
		this.saveConnections(source);
	}

	moveConnection(conn: any) {
		let source = conn.originalSourceId;
		this.saveConnections(source);
	}

	saveConnections(source: string) {
		let stateConnections: any[] = [];
		let connections = jsPlumb.getConnections({ source: source });
		console.log('CONNECTIONS', connections);
		for (let connection of connections) {
			let connObj = connection.targetId;
			if ( stateConnections.indexOf(connObj) == -1 ) {
				stateConnections.push(connObj);
			}
		}
		this.modalInput.data.flowEnv.contenuto.workflow.connections[source] = stateConnections;
		this.modalInput.data.saved = false;
		// this.saveFlowLocalStorage();
	}

	saveFlowLocalStorage() {
		if (this.save) {
			localStorage.setItem('flowEnv', JSON.stringify(this.modalInput.data.flowEnv));
			console.log('save flowEnv', this.modalInput.data.flowEnv);
			this.modalInput.data.saved = false;
		}
	}

	loadFlowLocalStorage() {
		if (!this.reset) {
			console.log('load flowEnv');
			let loadedStorage = JSON.parse( localStorage.getItem('flowEnv') );
			if (loadedStorage) {
				this.modalInput.data.flowEnv = loadedStorage;
				console.log('loaded', this.modalInput.data.flowEnv);
			}
		}
	}

	editState(state:any) {
		console.log("PRE EDIT STATE SETTINGS",this.modalInput.data.flowEnv.contenuto.stateSettings[state.id]);
		this.modalInput.size = 'medium-modal';
		this.modalInput.title = 'Edita Stato';
		this.modalInput.subtitle = 'Modifica i parametri dello Stato';
		this.modalInput.height = 'fluid';
		this.modalInput.data.selected.newState = false;
		this.modalInput.data.selected.state = state;
		this.modalInput.data.selected.settings = this.modalInput.data.flowEnv.contenuto.stateSettings[state.id];
	}

	getModalOutput(event: any) {
 		switch (event.type) {
 			case 'saveEditedState':
 				let editedState = event.content;
 				this.saveEditedState(editedState);
 				break;

 			case 'safeSave':
 				this.safeSave();
 				break;

 			case 'makeNew':
 				let newFlow = event.content;
 				this.makeNew(newFlow);
 				break;

 			case 'saveNew':
 				let flowEnvNew = event.content;
 				this.saveNew(flowEnvNew);
 				break;

 			case 'updateFlow':
 				let flowEnvUpdate = event.content;
 				this.updateFlow(flowEnvUpdate);
 				break;

 			case 'loadFlow':
 				let flowId = event.content;
 				this.loadFlow(flowId);
 				break;

 			case 'setDefault':
 				let defaultFlow = event.content;
 				this.setDefaultFlow(defaultFlow);
 				break;
 		}
	}

	// modalEvents(event: any) {
 // 		switch (event.type) {

 // 			case 'saveEditedState':
 // 				let editedState = event.content;
 // 				this.saveEditedState(editedState);
 // 				break;

 // 			case 'safeSave':
 // 				this.safeSave();
 // 				break;

 // 			case 'makeNew':
 // 				let newFlow = event.content;
 // 				this.makeNew(newFlow);
 // 				break;

 // 			case 'saveNew':
 // 				let flowEnvNew = event.content;
 // 				this.saveNew(flowEnvNew);
 // 				break;

 // 			case 'updateFlow':
 // 				let flowEnvUpdate = event.content;
 // 				this.updateFlow(flowEnvUpdate);
 // 				break;

 // 			case 'loadFlow':
 // 				let flowId = event.content;
 // 				this.loadFlow(flowId);
 // 				break;

 // 			case 'setDefault':
 // 				let defaultFlow = event.content;
 // 				this.setDefaultFlow(defaultFlow);
 // 				break;
 // 		}
	// }

	apriNuovoFlusso(){
		this.modalInput.size = 'middle-modal';
		this.modalInput.title = 'Nuovo Flusso';
		this.modalInput.subtitle = '';
		this.modalInput.height = 'fluid';
	}

	apriCaricaFlusso(){
		this.modalInput.size = 'middle-modal';
		this.modalInput.title = 'Carica Flusso';
		this.modalInput.subtitle = '';
		this.modalInput.height = 'fluid';
	}

	apriSalvaFlusso(){
		this.modalInput.size = 'middle-modal';
		this.modalInput.title = 'Salva Flusso';
		this.modalInput.subtitle = '';
		this.modalInput.height = 'fluid';
	}

	apriGestisciFlussi(){
		this.modalInput.size = 'middle-modal';
		this.modalInput.title = 'Gestisci Flussi';
		this.modalInput.subtitle = '';
		this.modalInput.height = 'fluid';
	}

	checkData() {
		console.log('CHECK DATA WF', this.modalInput);

		setTimeout(
			() => {
				console.log('CHECK DATA WF 2', this.modalInput);
			} , 1000
			)
	}

	saveEditedState(editedState: any) {
		console.log('saveEditedState PRE',editedState,this.modalInput.data.flowEnv.contenuto.stateSettings[editedState.id]);
		if (editedState.newState) {
			this.createCustomState(editedState);
		}
		else {
			this.modalInput.data.flowEnv.contenuto.stateSettings[editedState.id] = _.cloneDeep(editedState.settings);
			if ( editedState.state.tipo == 'custom' ) {
				for (let state of this.modalInput.data.flowEnv.contenuto.workflow.states) {
					if (state.id == editedState.state.id) {
						state = editedState.state;
						return;
					}
				}
			}
		}
		console.log('saveEditedState POST',this.modalInput.data.flowEnv.contenuto.stateSettings[editedState.id]);
		// this.saveFlowLocalStorage();
	}

	safeSave() {
		console.log('safeSave');
		document.getElementById('saveModalButton').click();
	}

	makeNew(newFlow: any) {
		console.log('newFlow', newFlow);
		this.newFlow(newFlow);
	}

	saveNew(flowEnv: any) {
		this.dataService.openLoader('INSERIMENTO FLUSSO','aggiunta nuovo flusso in corso...');
		let toDB: any = _.cloneDeep(flowEnv);
		toDB.contenuto = JSON.stringify( toDB.contenuto );
		console.log('toDB',toDB);

		this.dataService.insert("flussi_pratica", toDB, true, (error,newId) => {
			if (error) {
				this.dataService.closeLoader();
				this.dataService.openMessage('INSERIMENTO FLUSSO','si è verificato un errore');
			}
			else {
				this.modalInput.data.saved = true;
				this.modalInput.data.flowEnv.id = newId;
				this.modalInput.data.flowEnv.nome = flowEnv.nome;
				this.modalInput.data.flowEnv.descrizione = flowEnv.descrizione;
				console.log('saveNew', this.modalInput.data.saved, this.modalInput.data.flowEnv, newId);
				this.dataService.closeLoader();
			}
		});
	}

	updateFlow(flowEnv: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.modalInput.data.flowEnv.id });
		let toDB: any = _.cloneDeep(flowEnv);
		toDB.contenuto = JSON.stringify( toDB.contenuto );

		this.dataService.update("flussi_pratica", localFilters, toDB, true, (error,res) => {
			if(res){
				this.modalInput.data.saved = true;
			}
		});
	}

	loadFlow(id: any) {
		console.log('loadFlow',id);

		let loadedFlow: any = this.dataService.getFlowById(id);
		if (loadedFlow) {
			console.log('flusso caricato:', loadedFlow);
			this.startReset();
			// this.setEmptyFlowEnv();
			console.log('flusso caricato: RESET');
			jsPlumb.reset();
			console.log('flusso caricato: IMPORT DEFAULTS');
			jsPlumb.importDefaults(this.jsPlumbDefaults);
			// loadedFlow.contenuto = JSON.parse(loadedFlow.contenuto);
			console.log('flusso caricato: SET BINDINGS');
			// this.setBindings();
			this.modalInput.data.flowEnv = loadedFlow;
			console.log('flusso caricato: DEFAULT STATES', this.modalInput.data.flowEnv.contenuto.workflow.states);
			this.setDefaultStates(); // ?
		}
		else {
			console.log('flusso non caricato');
		}
	}

	setDefaultFlow(id: any) {
		console.log('defaultFlow', id);
		if (id != this.modalInput.data.flowEnv) {
			this.modalInput.data.flowEnv.attivo = '-1';
		}
		else {
			this.modalInput.data.flowEnv.attivo = '1';
		}
	}

	ngOnDestroy() {
		this.activeFlowSync.unsubscribe();
		this.defaultStatesSync.unsubscribe();
		jsPlumb.reset();
	}
}
